import React, {Component} from 'react';
import {connect} from 'react-redux';
import Const from 'constants';
import RemoveStackItem from './remove-stack-item';

class Stacks extends Component {
    getStackLabel(stack) {
        let str = 'Stack ';

        if (stack.type === Const.STACKS_TYPE_AT_LEAST) {
            str += 'At least ';
        } else if (stack.type === Const.STACKS_TYPE_EXACTLY) {
            str += 'Exactly ';
        } else if (stack.type === Const.STACKS_TYPE_AT_MOST) {
            str += 'At most ';
        }

        str += `${stack.numberPlayers} dominators`;

        return str;
    }

    render() {
        const {stacking} = this.props;
        const items = stacking.getItems();

        return (
            <div className="advanced-tags">
                {Object.values(items).map((item) => {
                    return (
                        <span key={item.getId()} className="advanced-tag">
                            {this.getStackLabel(item)}
                            <RemoveStackItem itemId={item.getId()} />
                        </span>
                    );
                })}
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {dominatorStacking} = state;
    return {
        stacking: dominatorStacking,
    };
}

export default connect(mapStatesToProps)(Stacks);
